import React from "react";
import {Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Slider} from "@material-ui/core";
import {enabledField} from "./index";

const PresetMobileSettings = (props) => {
    const { classes, translations, values, methods, securazeSolutions, verify, valueText, handleChange, osType="Android", setFieldValue } = props;
    
    const name = `ErasureMobile.${osType}`;

    const fieldNames = {
        PrintUponConnection: `${name}.PrintUponConnection`,
        PrintUponSuccessfulErasure: `${name}.PrintUponSuccessfulErasure`,
        PrintUponFailedOrAbortedErasure: `${name}.PrintUponFailedOrAbortedErasure`,
        PrintUponDiagnose: `${name}.PrintUponDiagnose`,
        RemoveAppAfterDiagnose: `${name}.RemoveAppAfterDiagnose`,
        ErasureAfterDiagnose: `${name}.ErasureAfterDiagnose`,
        MethodMobile: `${name}.MethodMobile`,
        TypeMobile: `${name}.TypeMobile`,
        VerificationMobile: `${name}.VerificationMobile`,
        CustomValueMobile: `${name}.CustomValueMobile`,
        UserKPIEnabled: `${name}.UserKPIEnabled`,
        UserKPICountDiagnosedDevices: `${name}.UserKPICountDiagnosedDevices`,
        UserKPICountRegisteredDevices: `${name}.UserKPICountRegisteredDevices`
    }

    const fieldValues = {
        PrintUponConnection: values["ErasureMobile"][osType]["PrintUponConnection"],
        PrintUponSuccessfulErasure: values["ErasureMobile"][osType]["PrintUponSuccessfulErasure"],
        PrintUponFailedOrAbortedErasure: values["ErasureMobile"][osType]["PrintUponFailedOrAbortedErasure"],
        PrintUponDiagnose: values["ErasureMobile"][osType]["PrintUponDiagnose"],
        RemoveAppAfterDiagnose: values["ErasureMobile"][osType]["RemoveAppAfterDiagnose"],
        ErasureAfterDiagnose: values["ErasureMobile"][osType]["ErasureAfterDiagnose"],
        MethodMobile: values["ErasureMobile"][osType]["MethodMobile"],
        TypeMobile: values["ErasureMobile"][osType]["TypeMobile"],
        VerificationMobile: values["ErasureMobile"][osType]["VerificationMobile"],
        CustomValueMobile: values["ErasureMobile"][osType]["CustomValueMobile"],
        UserKPIEnabled: values["ErasureMobile"][osType]["UserKPIEnabled"],
        UserKPICountDiagnosedDevices: values["ErasureMobile"][osType]["UserKPICountDiagnosedDevices"],
        UserKPICountRegisteredDevices: values["ErasureMobile"][osType]["UserKPICountRegisteredDevices"]
    }

    return (
        <>
            <FormControl className={classes.formControl} margin={"dense"}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["PrintUponConnection"]}
                                checked={(fieldValues["PrintUponConnection"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_connection'] || 'Print upon connection'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["PrintUponSuccessfulErasure"]}
                                checked={(fieldValues["PrintUponSuccessfulErasure"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_successful_erasure'] || 'Print upon successful erasure'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["PrintUponFailedOrAbortedErasure"]}
                                checked={(fieldValues["PrintUponFailedOrAbortedErasure"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_failed_or_aborted_erasure'] || 'Print upon failed or aborted erasure'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["PrintUponDiagnose"]}
                                checked={(fieldValues["PrintUponDiagnose"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['print_upon_diagnose'] || 'Print upon diagnose'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["RemoveAppAfterDiagnose"]}
                                checked={(fieldValues["RemoveAppAfterDiagnose"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['remove_app_after_diagnose'] || 'Remove app after diagnose'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["ErasureAfterDiagnose"]}
                                checked={(fieldValues["ErasureAfterDiagnose"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['erasure_after_diagnose'] || 'Erasure after diagnose'}`}
                    />
                </FormGroup>
                {/* <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["UserKPIEnabled"]}
                                checked={(fieldValues["UserKPIEnabled"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['enabled'] || 'Enabled'}`}
                    />
                </FormGroup> */}
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["UserKPICountDiagnosedDevices"]}
                                checked={(fieldValues["UserKPICountDiagnosedDevices"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['count_diagnosed_devices'] || 'Count diagnosed devices'}`}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["UserKPICountRegisteredDevices"]}
                                checked={(fieldValues["UserKPICountRegisteredDevices"]) || false}
                                disabled={enabledField(values)}
                                onChange={handleChange}
                            />
                        }
                        label={`${translations['count_registered_devices'] || 'Count registered devices'}`}
                    />
                </FormGroup>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations['securaze_standard_mobile_text'] || "Please select mobile securaze standard"}</InputLabel>
                <Select
                    name={fieldNames["MethodMobile"]}
                    label={translations['wipe_method_mobile'] || 'Mobile Erasure method'}
                    margin={"dense"}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues["MethodMobile"] || ""}
                >
                    {(methods ? methods : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations['securaze_solution_mobile_text'] || "Please select mobile securaze solution"}</InputLabel>
                <Select
                    name={fieldNames["TypeMobile"]}
                    label={translations['securaze_solution_mobile'] || 'Mobile securaze solution'}
                    margin={"dense"}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues["TypeMobile"] || ""}
                >
                    {(securazeSolutions ? securazeSolutions : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["wipe_verify_mobile_text"] || "Please select mobile verify method"}</InputLabel>
                <Select
                    name={fieldNames["VerificationMobile"]}
                    label={translations['VerificationMobile'] || 'Wipe verify mobile'}
                    margin={"dense"}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                    value={fieldValues["VerificationMobile"] || ""}
                >
                    {(verify ? verify : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues["VerificationMobile"] === 'custom' ?
                <>
                    <InputLabel shrink>{translations["select_verification_percentage"] || "Please select verification percentage"}</InputLabel>
                    <Slider
                        name={fieldNames["CustomValueMobile"]}
                        defaultValue={fieldValues["CustomValueMobile"]}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames["CustomValueMobile"], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />  </> : <><br/> </>}
        </>
    )
}

export default PresetMobileSettings;
